module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_7016.098e7610.png";